import type { UserList } from '@/api/types'
import { Button } from '@/components/ui/Button'
import { Dialog } from '@/components/ui/Dialog'
import { useT } from '@/i18n'

import { useCreateList, useDeleteList, useUpdateList } from '../hooks/useLists'
import { ListForm } from './ListForm'

interface Props {
  open: boolean
  onClose: () => void
  /** 给了就是编辑，没给就是新建 */
  list?: UserList
  onSaved?: (list: UserList) => void
  onDeleted?: () => void
}

export function ListEditDialog({ open, onClose, list, onSaved, onDeleted }: Props) {
  const t = useT()
  const create = useCreateList()
  const update = useUpdateList(list?.id ?? '')
  const remove = useDeleteList()
  const mutation = list ? update : create

  return (
    <Dialog open={open} onClose={onClose} title={list ? t('lists.edit') : t('lists.create')}>
      <div className="space-y-4 px-4 pb-5">
        <ListForm
          initial={list}
          submitLabel={list ? t('common.save') : t('lists.create')}
          pending={mutation.isPending}
          error={mutation.error}
          onSubmit={(input) =>
            mutation.mutate(input, {
              onSuccess: ({ list: saved }) => {
                onSaved?.(saved)
                onClose()
              },
            })
          }
        />
        {list && (
          <Button
            variant="ghost"
            fullWidth
            className="text-danger"
            loading={remove.isPending}
            onClick={() => {
              if (!window.confirm(t('lists.confirmDelete', { name: list.name }))) return
              remove.mutate(list.id, {
                onSuccess: () => {
                  onClose()
                  onDeleted?.()
                },
              })
            }}
          >
            {t('lists.delete')}
          </Button>
        )}
      </div>
    </Dialog>
  )
}
